import { render } from "./HomeIndex.vue?vue&type=template&id=3b0e635d&scoped=true"
import script from "./HomeIndex.vue?vue&type=script&lang=js"
export * from "./HomeIndex.vue?vue&type=script&lang=js"

import "./HomeIndex.vue?vue&type=style&index=0&id=3b0e635d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0e635d"]])

export default __exports__